import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  role: "",
  username: "",
  domain: "",
  roleCount: 0,
  clientid: "",
  eventmodal: false,
};

export const userDetails = createSlice({
  name: "userDetials",
  initialState,
  reducers: {
    updateRole: (state, action) => {
      state.role = action.payload;
    },
    updateUsername: (state, action) => {
      state.username = action.payload;
    },
    updateDomain: (state, action) => {
      state.domain = action.payload;
    },
    updateRoleCount: (state, action) => {
      state.roleCount = action.payload;
    },
    updateClientId: (state, action) => {
      state.clientid = action.payload;
    },
    updateEventModal: (state, action) => {
      state.eventmodal = action.payload;
    },
    resetUserSlice: () => {
      return initialState;
    },
  },
});

export const {
  updateRole,
  updateEventModal,
  updateUsername,
  updateRoleCount,
  updateClientId,
  resetUserSlice,
} = userDetails.actions;

export const userDetailsReducer = userDetails.reducer;
